<template>
  <v-card class="mt-1 pa-0">
    
    <DevTables2 v-if="tableItems === null" :tblHeaders="tableHeader" :tblItems="aryEmpty" tblHeight="calc(100vh - 220px)"/>
    <DevTables2 v-else :tblHeaders="tableHeader" :tblItems="tableItems" tblHeight="calc(100vh - 220px)"
      :ppSn="pSn" :ppDate1="pDate1" :ppDate2="pDate2" @tblEmit="onEmitTbl2" :trigger2="trigger"/> 

  </v-card>
</template>

<script>
import DevTables2 from '@/components/DevInfoPage/DevTables2'
//import * as Samples from "@/js/samples/data.js"
import * as Tbl from "@/js/tables.js"

  export default {
    name: 'TblEventWarning',

    components: {
      DevTables2
    },

    props: {
      tableItems: {type: Array},
      pSn: {type: String, default: ''},
      pDate1: {type: String, default: ''},
      pDate2: {type: String, default: ''},
      trigger: {type: Number, default: 0}
    },

    data () {
      return {
        tableHeader: Tbl.TblWarningHeaders2,
        aryEmpty: []
        //tableItems:  Samples.WarningData2
      }
    },

    methods: {
      onEmitTbl2(xstr) {
        //console.log("##TblEventWarn-112");  //debug
        this.$emit("tblDevEmit", xstr);
      }      
    }
  }
</script>

<style>
</style>
